/* eslint-disable */
import { endpoints } from '../../Constants';
import { authHeader } from '../../Helpers';
import handleResponse from '../helpers';

const fetchDepartmentsList = async () => {
	const requestOptions = {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
			...authHeader(),
		},
	};

	// return mockResponse(requestOptions);
	return fetch(endpoints.DEPARTMENTS, requestOptions).then(
		handleResponse
	);
};

const getDepartment = async (req) => {
	const requestOptions = {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			...authHeader(),
		},
		body: JSON.stringify(req),
	};

	// return mockResponse(requestOptions);
	return fetch(endpoints.DEPARTMENTS_EDIT, requestOptions).then(
		handleResponse
	);
};

const createDepartment = async (req) => {
	const requestOptions = {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			...authHeader(),
		},
		body: JSON.stringify(req),
	};

	// return mockResponse(requestOptions);
	return fetch(endpoints.DEPARTMENTS_EDIT, requestOptions).then(
		handleResponse
	);
};

const updateDepartment = async (req) => {
	const requestOptions = {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			...authHeader(),
		},
		body: JSON.stringify(req),
	};

	// return mockResponse(requestOptions);
	return fetch(endpoints.DEPARTMENTS_EDIT, requestOptions).then(
		handleResponse
	);
};

const deleteDepartment = async (req) => {
	const requestOptions = {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			...authHeader(),
		},
		body: JSON.stringify(req),
	};

	// return mockResponse(requestOptions);
	return fetch(endpoints.DEPARTMENTS_DELETE, requestOptions).then(
		handleResponse
	);
};

const deleteParameterDepartment = async (req) => {
	const requestOptions = {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			...authHeader(),
		},
		body: JSON.stringify(req),
	};

	return fetch(endpoints.DEPARTMENTS_PARAMETER_DELETE, requestOptions).then(
		handleResponse
	);
};

const fetchDepartmentsAuditList = async () => {
	const requestOptions = {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
			...authHeader(),
		},
	};

	// return mockResponse(requestOptions);
	return fetch(endpoints.DEPARTMENTS_AUDIT_LIST, requestOptions).then(
		handleResponse
	);
};

const startDepartmentsAudit = async (req) => {
	const requestOptions = {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			...authHeader(),
		},
		body: JSON.stringify(req),
	};

	// return mockResponse(requestOptions);
	return fetch(endpoints.DEPARTMENTS_AUDIT, requestOptions).then(
		handleResponse
	);
};


const departmentServices = {
	fetchDepartmentsList,
	getDepartment,
	createDepartment,
	updateDepartment,
	deleteDepartment,
	fetchDepartmentsAuditList,
	startDepartmentsAudit,
	deleteParameterDepartment,
};

export default departmentServices;
